module.exports = __webpack_public_path__ + "img/images/whyhost/getStarted.png?feb4431e";